import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const LANGUAGE_LOCAL_STORAGE_KEY = "appLanguage";
const SUPPORTED_LANGUAGES = ["en", "hi", "ar", "ru"];

const localeModules = import.meta.glob("../locales/*/**/*.json", {
  eager: true,
});

const buildResources = () => {
  const resources = {};
  Object.keys(localeModules).forEach((modulePath) => {
    const match = modulePath.match(/\.\.\/locales\/([^/]+)\/(.+)\.json$/);
    if (!match) return;

    const language = match[1];
    const namespacePath = match[2];
    const namespace = namespacePath.split("/").pop();
    const content = localeModules[modulePath]?.default ?? localeModules[modulePath];

    if (!resources[language]) resources[language] = {};
    resources[language][namespace] = content;
  });

  return resources;
};

const syncDocumentLanguage = (language) => {
  if (typeof document === "undefined") return;
  document.documentElement.lang = language;
  // Keep layout direction stable across all languages.
  document.documentElement.dir = "ltr";
};

const getInitialLanguage = () => {
  if (typeof window === "undefined") return "en";
  try {
    const stored = localStorage.getItem(LANGUAGE_LOCAL_STORAGE_KEY);
    if (stored && SUPPORTED_LANGUAGES.includes(stored)) {
      return stored;
    }
  } catch {
    // Ignore storage access failures and use fallback language.
  }
  return "en";
};

const initialLanguage = getInitialLanguage();

i18n.use(initReactI18next).init({
  resources: buildResources(),
  lng: initialLanguage,
  fallbackLng: "en",
  ns: [
    "common",
    "login",
    "sidebar",
    "navbar",
    "dashboard",
    "message",
    "converter",
    "subscription",
    "pcapReport",
    "summaryDelivery",
    "submissionReport",
    "batchSummary",
    "dailyUsage",
    "tpsReport",
    "lookupReport",
    "deliverySmsc",
    "resumeTraffic",
    "performanceUser",
    "profitReport",
    "aggregatedReport",
    "performanceRoute",
    "saveFilter",
    "userFilter",
    "blockedReport",
    "coverage",
    "costEfficiency",
    "edrReport",
    "docPdfViewer",
    "addressBook",
    "templates",
    "company",
    "vendor",
    "sales",
    "bsfmTable",
    "manageBulkLogs",
    "user",
    "addRouting",
    "principalDlt",
    "templateDlt",
    "network",
  ],
  defaultNS: "common",
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

syncDocumentLanguage(i18n.language);
i18n.on("languageChanged", syncDocumentLanguage);

export default i18n;
